module.exports = __webpack_public_path__ + "img/campaign-auto-nights.9c515a25.jpg";